<modal-container
  #modal
  [ignoreBackdropClick]="true"
  (hide)="onHideChildModal()"
  [headerIconClass]="modalHeaderIcon"
  [headerTitle]="modalTitle"
  [modalHeaderBgColorClass]="
    type === 'in'
      ? 'header-class bg_green'
      : type === 'out'
        ? 'header-class bg_red'
        : type === 'transfer'
          ? 'header-class bg_orange'
          : ''
  "
  [modalBodyBgColorClass]="
    type === 'in' ? 'bg_green' : type === 'out' ? 'bg_red' : type === 'transfer' ? 'bg_orange' : ''
  "
  [modalFooterBgColorClass]="
    type === 'in' ? 'bg_green' : type === 'out' ? 'bg_red' : type === 'transfer' ? 'bg_orange' : ''
  "
  [isLargeModal]="true"
>
  <ng-container class="modal-button-show">
    @if (isCreatingProduct && !hideButton) {
      <btn
        [classes]="['btn-second']"
        (onEvent)="showChildModal()"
        [icon]="'far-plus'"
        [label]="'product.create'"
        [title]="'product.create' | translate"
        [isLoading]="loading"
        [attr.data-cy]="dataCyAttribute"
      ></btn>
    }
    @if (!isCreatingProduct && !operationToUpdate && !hideButton) {
      <btn
        [isLoading]="loading"
        [classes]="['btn-second', 'btn-sm']"
        [icon]="'far-check'"
        [label]="'select'"
        (onEvent)="showChildModal()"
        [title]="'select' | translate"
        [attr.data-cy]="dataCyAttribute"
      ></btn>
    }
    @if (operationToUpdate) {
      <btn
        [classes]="['btn-edit']"
        [isLoading]="loading"
        (onEvent)="showChildModal()"
        [icon]="'far-pencil'"
        [title]="'open' | translate"
        [attr.data-cy]="dataCyAttribute"
      ></btn>
    }
  </ng-container>
  @if (type === 'in' || type === 'transfer') {
    <ng-container class="modal-body-content">
      <div class="container-fluid ps-0 pe-0">
        <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
        <!--        TODO: stock overview - by depot!!!-->
        @if (!loading) {
          <div class="stock-operation-card--content">
            <div class="card" style="padding: 26px">
              @if (product && isCreatingProduct && !isCreatedProduct) {
                <div>
                  <div class="row">
                    <form-row-input
                      class="col-12"
                      [label]="'product.name'"
                      [icon]="'far-file-alt'"
                      [(model)]="product.name"
                      [required]="true"
                      [requiredCssClass]="submitted && !product.name"
                      [dataCyAttribute]="'name'"
                    ></form-row-input>
                  </div>
                  <div class="row">
                    <form-row-input
                      class="col-4"
                      [label]="'product.code'"
                      [icon]="'far-tag'"
                      [(model)]="product.code"
                      [dataCyAttribute]="'code'"
                    ></form-row-input>
                    <form-row-input
                      class="col-8"
                      [label]="'product.ean'"
                      [icon]="'far-barcode'"
                      [model]="product.ean"
                      [translateBarcode]="true"
                      (modelChange)="setEan($event)"
                      [appendBtnIcon]="!product.ean || (product.ean && product.ean.length < 1) ? 'far-barcode' : null"
                      [appendBtnLabel]="
                        !product.ean || (product.ean && product.ean.length < 1) ? 'product.ean.generate' : null
                      "
                      [appendBtnClasses]="['btn', 'btn-ean']"
                      (onAppendBtnEvent)="fillNextEan()"
                      [dataCyAttribute]="'ean'"
                    >
                    </form-row-input>
                  </div>
                  <div class="row">
                    <form-row-input
                      class="col-4"
                      [label]="'product.price.sale'"
                      [icon]="'far-money-bill'"
                      [(model)]="product.sellPrice"
                      [replaceComma]="true"
                      [dataCyAttribute]="'sale-price'"
                      [required]="true"
                      [requiredCssClass]="
                        submitted &&
                        (this.product?.sellPrice < 0 || (!this.product?.sellPrice && this.product?.sellPrice !== 0))
                      "
                    ></form-row-input>
                    <form-row-input
                      class="col-4"
                      [label]="'product.price.before'"
                      [icon]="'far-money-bill-alt'"
                      [(model)]="product.beforeSellPrice"
                      [replaceComma]="true"
                      [dataCyAttribute]="'price-before'"
                    ></form-row-input>
                    <div class="form-group col-4">
                      <label>{{ 'product.vatrate' | translate }}:</label>
                      <div class="input-group">
                        <select
                          name="vatRate"
                          id="vatRate"
                          class="form-control"
                          [ngModel]="product?.vat?.id"
                          (ngModelChange)="selectVat($event)"
                          data-cy="vat"
                        >
                          @for (vat of vats; track vat) {
                            <option [value]="vat.id">{{ vat.name }} ({{ vat.percent }}%)</option>
                          }
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <form-row-input
                      class="col-4"
                      [label]="'product.weight'"
                      [icon]="'far-tachometer'"
                      [(model)]="product.weight"
                      [inputType]="'number'"
                      [dataCyAttribute]="'weight'"
                    ></form-row-input>
                    <form-row-select
                      class="col-8"
                      [label]="'product.producer'"
                      [icon]="'far-industry'"
                      [model]="product.producer ? product.producer.id : null"
                      (modelChange)="selectProducer($event)"
                      [optionKey]="'id'"
                      [optionKeyText]="'name'"
                      [options]="producers"
                    ></form-row-select>
                  </div>
                  <div class="row">
                    <div class="form-group product-parent col-8">
                      <label>{{ 'product.parent' | translate }}:</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          [ngModel]="
                            product.parent && product.parent.fullName && product.parent.fullName.length > 0
                              ? product.parent.fullName
                              : ''
                          "
                          disabled
                        />
                      </div>
                    </div>
                    <div class="mt-4 mb-3 col-4">
                      <modal-product-parent
                        [product]="product"
                        [depots]="depots"
                        [suppliers]="suppliers"
                        (result)="setParent($event)"
                      ></modal-product-parent>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                      <form-row-toggle
                        [(model)]="product.enabled"
                        [label]="'product.enabled'"
                        [classesString]="'text-nowrap'"
                      >
                      </form-row-toggle>
                    </div>
                  </div>
                  <div class="row mt-2">
                    <div class="col-12">
                      <form-row-toggle
                        [(model)]="product.isForSubsequentSettlement"
                        [label]="'product.isForSubsequentSettlement'"
                        [tooltipIcon]="'fa-info-circle'"
                        [tooltipLabel]="'isForSubsequentSettlement.info'"
                        [classesString]="'text-nowrap'"
                      >
                      </form-row-toggle>
                      <!--                <form-row-toggle-->
                      <!--                  [(model)]="product.isPML"-->
                      <!--                  [label]="'product.isPML'"-->
                      <!--                  [tooltipIcon]="'fa-info-circle'"-->
                      <!--                  [tooltipLabel]="'isPML.info'"-->
                      <!--                  [classesString]="'text-nowrap'"-->
                      <!--                >-->
                      <!--                </form-row-toggle>-->
                      <!--                <form-row-toggle-->
                      <!--                  [(model)]="product.isAdultOnly"-->
                      <!--                  [label]="'product.isAdultOnly'"-->
                      <!--                  [tooltipIcon]="'fa-info-circle'"-->
                      <!--                  [tooltipLabel]="'isAdultOnly.info'"-->
                      <!--                  [classesString]="'text-nowrap'"-->
                      <!--                >-->
                      <!--                </form-row-toggle>-->
                    </div>
                  </div>
                </div>
              }
              @if (isCreatedProduct) {
                <div class="form-operation-card">
                  <div class="row">
                    @if (type === 'in' || type === 'transfer') {
                      <div class="col-12 ps-0 pe-0">
                        @if (type === 'in') {
                          <form-row-select
                            [label]="'product.supplier.colon'"
                            [icon]="'far-truck'"
                            [(model)]="selectedSupplier"
                            [options]="suppliers"
                            [optionKey]="'id'"
                            [optionKeyText]="'name'"
                            [dataCyAttribute]="'product-supplier-select'"
                          ></form-row-select>
                        }
                        @if (type === 'transfer') {
                          <form-row-input
                            [label]="'product.supplier.colon'"
                            [icon]="'far-truck'"
                            [model]="productDepot?.supplier?.name"
                            (modelChange)="productDepot.supplier.name = $event"
                            [dataCyAttribute]="'product-supplier-input-disabled'"
                            [inputDisabled]="true"
                          ></form-row-input>
                        }
                      </div>
                    }
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 ps-0">
                      <form-row-input
                        [label]="'product.code'"
                        [icon]="'far-tag'"
                        [model]="product.code"
                        [inputDisabled]="true"
                      ></form-row-input>
                    </div>
                    <div class="col-12 col-sm-6 pe-0">
                      <form-row-input
                        [label]="'product.ean'"
                        [icon]="'far-barcode'"
                        [model]="product.ean"
                        [inputDisabled]="true"
                      ></form-row-input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-sm-6 ps-0">
                      <form-row-input
                        [label]="'product.batch'"
                        [icon]="'far-cubes'"
                        [(model)]="batch"
                        [inputDisabled]="type === 'transfer'"
                      >
                      </form-row-input>
                    </div>
                    <div class="col-12 col-sm-6 pe-0">
                      <form-row-input
                        [inputType]="'date'"
                        [label]="'product.expirationDate'"
                        [icon]="'far-clock'"
                        [model]="expirationDate | fmtDate: 'yyyy-MM-dd'"
                        (modelChange)="expirationDate = $event"
                        [inputDisabled]="type === 'transfer'"
                      ></form-row-input>
                    </div>
                  </div>
                  <div class="row stock-positions">
                    <div class="col-12 col-sm-4 input-dash position-relative">
                      <span class="stock-positions-absolute">{{
                        type === 'transfer' ? ('stock.positions.new' | translate) : ('stock.positions' | translate)
                      }}</span>
                      <form-row-input [label]="'row'" [icon]="'far-box'" [(model)]="position1"></form-row-input>
                      <div class="align-self-center mt-2">-</div>
                    </div>
                    <div class="col-12 col-sm-4 input-dash">
                      <form-row-input [label]="'aisle'" [icon]="'far-box'" [(model)]="position2"></form-row-input>
                      <div class="align-self-center mt-2">-</div>
                    </div>
                    <div class="col-12 col-sm-4">
                      <form-row-input [label]="'shelf'" [icon]="'far-box'" [(model)]="position3"></form-row-input>
                      @if (type === 'in') {
                        <span>
                          <modal-existing-positions
                            [product]="product"
                            [depot]="depotTo"
                            (setPosition)="setPosition($event)"
                          >
                          </modal-existing-positions>
                        </span>
                      }
                    </div>
                  </div>
                  <div class="row mt-2">
                    @if (!operationToUpdate && type !== 'transfer') {
                      <div class="col ps-0">
                        <form-row-input
                          [inputType]="'number'"
                          [label]="'quantity'"
                          [icon]="'far-list'"
                          [(model)]="quantity"
                          [appendBtnClasses]="['btn-input']"
                        ></form-row-input>
                      </div>
                    }
                    @if (!operationToUpdate && type === 'transfer') {
                      <div class="col ps-0 flex-gap-0-1">
                        <form-row-input
                          [inputType]="'number'"
                          [label]="'quantity'"
                          [icon]="'far-list'"
                          [(model)]="quantity"
                          [appendBtnIcon]="'fa-boxes-stacked'"
                          [appendBtnTitle]="'modal-stock-operation-card.all-pieces'"
                          (onAppendBtnEvent)="allPiecesSelected(productDepot)"
                          [appendBtnClasses]="['btn-input']"
                          [maximumVal]="type === 'transfer' ? productDepot.quantityStock : null"
                        ></form-row-input>
                      </div>
                    }
                    @if (operationToUpdate && type !== 'transfer') {
                      <div class="col">
                        <form-row-input
                          [inputType]="'number'"
                          [label]="'quantity'"
                          [icon]="'far-list'"
                          [(model)]="quantity"
                          [maximumVal]="type === 'out' ? operationToUpdate.productDepotFrom.quantityStock : null"
                        ></form-row-input>
                      </div>
                    }
                    @if (operationToUpdate && type === 'transfer') {
                      <div class="col">
                        <form-row-input
                          [inputType]="'number'"
                          [label]="'quantity'"
                          [icon]="'far-list'"
                          [(model)]="quantity"
                          [appendBtnIcon]="'fa-boxes-stacked'"
                          [appendBtnTitle]="'modal-stock-operation-card.all-pieces'"
                          (onAppendBtnEvent)="allPiecesSelected(productDepot)"
                          [maximumVal]="type === 'transfer' ? operationToUpdate.productDepotFrom.quantityStock : null"
                        ></form-row-input>
                      </div>
                    }
                    <div class="col align-items-center">
                      <form-row-input
                        [label]="'purchasePrice'"
                        [icon]="'far-money-bill'"
                        [(model)]="purchasePrice"
                        [requiredCssClass]="!loading && !purchasePrice && purchasePrice !== 0"
                        [replaceComma]="true"
                      ></form-row-input>
                    </div>
                    <div class="col">
                      <form-row-select
                        [label]="'currency'"
                        [icon]="'far-money-bill-alt'"
                        [(model)]="selectedCurrency"
                        [options]="queryCurrencies.data()"
                      ></form-row-select>
                    </div>
                    @if (type === 'in') {
                      <div class="col-4 pe-0">
                        <form-row-input [label]="'duzp'" [inputType]="'date'" [(model)]="dateDUZP"></form-row-input>
                      </div>
                    }
                  </div>
                  <div class="row">
                    <div class="col-12 ps-0 pe-0">
                      <form-row-textarea
                        #inputNote
                        [label]="'note'"
                        [icon]="'far-list'"
                        [(model)]="note"
                        [rows]="4"
                      ></form-row-textarea>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
        @if (resultMessage.length) {
          <alert [type]="'info'">
            {{ resultMessage }}
          </alert>
        }
      </div>
    </ng-container>
  }

  @if (type === 'out') {
    <ng-container class="modal-body-content">
      <div class="container-fluid ps-0 pe-0">
        <loading-spinner [isLoading]="loading" [classesString]="'top-50'"></loading-spinner>
        <!--        TODO: stock overview - by depot!!!-->
        <div class="stock-operation-card--content">
          <div class="card" style="padding: 26px">
            @if (product && isCreatingProduct && !isCreatedProduct) {
              <div>
                <div class="row">
                  <form-row-input
                    class="col-12"
                    [label]="'product.name'"
                    [icon]="'far-file-alt'"
                    [(model)]="product.name"
                    [dataCyAttribute]="'name'"
                  ></form-row-input>
                </div>
                <div class="row">
                  <div class="form-group product-parent col-8">
                    <label>{{ 'product.parent' | translate }}:</label>
                    <div class="input-group">
                      <input
                        type="text"
                        class="form-control"
                        [ngModel]="
                          product.parent && product.parent.name && product.parent.name.length > 0
                            ? product.parent.name
                            : ''
                        "
                        disabled
                      />
                    </div>
                  </div>
                  <div class="mt-4 mb-3 col-4">
                    <modal-product-parent
                      [product]="product"
                      [depots]="depots"
                      [suppliers]="suppliers"
                      (result)="setParent($event)"
                    ></modal-product-parent>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12">
                    <form-row-toggle
                      [(model)]="product.enabled"
                      [label]="'product.enabled'"
                      [classesString]="'text-nowrap'"
                    >
                    </form-row-toggle>
                  </div>
                </div>
                <div class="row mt-2">
                  <div class="col-12">
                    <form-row-toggle
                      [(model)]="product.isForSubsequentSettlement"
                      [label]="'product.isForSubsequentSettlement'"
                      [tooltipIcon]="'fa-info-circle'"
                      [tooltipLabel]="'isForSubsequentSettlement.info'"
                      [classesString]="'text-nowrap'"
                    >
                    </form-row-toggle>
                  </div>
                </div>
                <!--            <div class="row mt-2">-->
                <!--              <div class="col-12">-->
                <!--                <form-row-toggle-->
                <!--                  [(model)]="product.isPML"-->
                <!--                  [label]="'product.isPML'"-->
                <!--                  [tooltipIcon]="'fa-info-circle'"-->
                <!--                  [tooltipLabel]="'isPML.info'"-->
                <!--                  [classesString]="'text-nowrap'"-->
                <!--                >-->
                <!--                </form-row-toggle>-->
                <!--              </div>-->
                <!--            </div>-->
                <!--            <div class="row mt-2">-->
                <!--              <div class="col-12">-->
                <!--                <form-row-toggle-->
                <!--                  [(model)]="product.isAdultOnly"-->
                <!--                  [label]="'product.isAdultOnly'"-->
                <!--                  [tooltipIcon]="'fa-info-circle'"-->
                <!--                  [tooltipLabel]="'isAdultOnly.info'"-->
                <!--                  [classesString]="'text-nowrap'"-->
                <!--                >-->
                <!--                </form-row-toggle>-->
                <!--              </div>-->
                <!--            </div>-->
              </div>
            }
            @if (isCreatedProduct) {
              <div class="form-operation-card">
                <div class="row mt-2" style="display: flex; justify-content: space-between">
                  @if (!operationToUpdate) {
                    <div class="col-6">
                      <form-row-input
                        [inputType]="'number'"
                        [label]="'quantity'"
                        [icon]="'far-list'"
                        [model]="quantity"
                        [maximumVal]="depotQuantity"
                        [minimumVal]="1"
                        (modelChange)="quantityChanged($event)"
                        [appendBtnClasses]="['btn-input']"
                      ></form-row-input>
                      <form-row-toggle
                        class="align-self-center"
                        [label]="'selectCustomPositions'"
                        [model]="selectCustomPositions"
                        (modelChange)="selectCustomPositionChange($event)"
                        [classesString]="'text-nowrap'"
                      ></form-row-toggle>
                    </div>
                  }
                  @if (operationToUpdate && type !== 'transfer') {
                    <div class="col-4">
                      <form-row-input
                        [inputType]="'number'"
                        [label]="'quantity'"
                        [icon]="'far-list'"
                        [(model)]="quantity"
                      ></form-row-input>
                    </div>
                  }
                  @if (operationToUpdate && type === 'transfer') {
                    <div class="col-4">
                      <form-row-input
                        [inputType]="'number'"
                        [label]="'quantity'"
                        [icon]="'far-list'"
                        [appendBtnIcon]="'fa-boxes-stacked'"
                        [appendBtnTitle]="'modal-stock-operation-card.all-pieces'"
                        (onAppendBtnEvent)="allPiecesSelected(productDepot)"
                        [(model)]="quantity"
                        [maximumVal]="productDepot.quantityStock"
                      ></form-row-input>
                    </div>
                  }
                  <div class="ps-4">
                    @for (img of product.images; track img) {
                      <div
                        class="img-card"
                        [photoGalleryGroup]="{ index: 1 }"
                        [photoGallery]="img.url"
                        [photoGalleryCaption]="
                          img.product
                            ? img.product.name +
                              '<br>' +
                              (img.product.code
                                ? ('modal-stock-operation-card.code' | translate) + img.product.code
                                : '') +
                              '<br>' +
                              (img.product.ean ? ('modal-stock-operation-card.ean' | translate) + img.product.ean : '')
                            : ''
                        "
                      >
                        <div class="img-container">
                          <div>
                            @if (!!img?.url?.length && !!img?.thumbnails?.length) {
                              <img class="images-item-image" [src]="getThumbUrl(img)" [alt]="img.text" />
                            }
                            @if (!img?.url?.length || !img?.thumbnails?.length) {
                              <img class="images-item-image" [src]="'assets/img/no-image.png'" [alt]="img.text" />
                            }
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                  @if (type === 'in' || type === 'transfer') {
                    <div class="col-6 d-flex gap-05">
                      <form-row-input
                        class="w-100"
                        [label]="'purchasePrice'"
                        [icon]="'far-money-bill'"
                        [(model)]="purchasePrice"
                        [replaceComma]="true"
                      ></form-row-input>
                      <p class="my-auto pt-2 font-size-input">{{ purchasePrice | formatCurrencyWithoutPrice }}</p>
                    </div>
                  }
                </div>
                <div class="table-responsive">
                  <table class="table m-0">
                    <thead>
                      <tr>
                        <th class="text-center">{{ 'product.position' | translate }}</th>
                        <th class="text-center">{{ 'product.expirationDate' | translate }}</th>
                        <th class="text-start">{{ 'product.batch' | translate }}</th>
                        <th class="text-end">{{ 'max' | translate }}</th>
                        <th class="text-end">{{ 'product.unload.ks' | translate }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (productDepot of productDepots; track productDepot) {
                        <tr>
                          <td class="text-center no-hover">{{ productDepot.position }}</td>
                          <td class="text-center no-hover">
                            {{
                              productDepot.expirationDate ? (productDepot.expirationDate | fmtDate: 'dd.MM.yyyy') : '-'
                            }}
                          </td>
                          <td class="text-start no-hover">{{ productDepot.batch ? productDepot.batch : '-' }}</td>
                          <td class="text-end no-hover">{{ productDepot.quantityStock }}</td>
                          @if (!selectCustomPositions) {
                            <td class="text-end no-hover">
                              {{ productDepot.amountToUnload | number: '1.0-2' | replaceCommaToDot }}
                            </td>
                          }
                          @if (selectCustomPositions && type === 'transfer') {
                            <td class="no-hover">
                              <form-row-input
                                [icon]="'far-minus'"
                                [model]="productDepot.amountToUnload"
                                (modelChange)="amountToUnloadChanged($event, productDepot)"
                                [inputType]="'number'"
                                [maximumVal]="productDepot.quantityStock"
                                [minimumVal]="0"
                              ></form-row-input>
                            </td>
                          }
                          @if (selectCustomPositions && type !== 'transfer') {
                            <td class="no-hover">
                              <form-row-input
                                [icon]="'far-minus'"
                                [model]="productDepot.amountToUnload"
                                (modelChange)="amountToUnloadChanged($event, productDepot)"
                                [inputType]="'number'"
                                [maximumVal]="productDepot.quantityStock"
                                [minimumVal]="0"
                              ></form-row-input>
                            </td>
                          }
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </ng-container>
  }

  <ng-container class="modal-footer-content">
    @if (isCreatingProduct && !isCreatedProduct) {
      <button
        type="submit"
        class="btn-first"
        (click)="createProduct()"
        [title]="'product.create' | translate"
        data-cy="submit"
      >
        <i class="far fa-check"></i>
        {{ 'product.create' | translate }}
      </button>
    }
    @if (!isCreatingProduct && !isCreatedProduct) {
      <button type="submit" class="btn-first" (click)="updateProduct()" [title]="'product.update' | translate">
        <i class="far fa-pencil"></i>
        {{ 'product.update' | translate }}
      </button>
    }
    @if (type === 'in' && isCreatedProduct) {
      <button
        type="submit"
        class="btn-first-green-inverted"
        (click)="createOperation()"
        [title]="'product.load' | translate"
        data-cy="stock-submit"
      >
        <i class="far fa-layer-plus"></i>
        {{ 'product.load' | translate }}
      </button>
    }
    @if (type === 'out' && isCreatedProduct) {
      <button
        type="submit"
        class="btn-first-red-inverted"
        (click)="createOperation()"
        [title]="'product.unload' | translate"
        data-cy="stock-submit"
      >
        <i class="far fa-layer-minus"></i>
        {{ 'product.unload' | translate }}
      </button>
    }
    @if (type === 'transfer' && isCreatedProduct) {
      <button
        type="submit"
        class="btn-first-orange-inverted"
        (click)="createOperation()"
        [title]="'product.transfer' | translate"
        data-cy="stock-submit"
      >
        <i class="far fa-exchange"></i>
        {{ 'product.transfer' | translate }}
      </button>
    }
  </ng-container>
</modal-container>
